import React from 'react';
import { mergeStyles, IStyle } from '@fluentui/react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Label } from '@fluentui/react-components';
import { labelStyles } from '../../app/common/styles/CommonStyleObjects';

interface ISpanWithLabelProps {
  labelText: string;
  subLabelText?: string;
  value?: string | boolean | Date | number;
  stackStyles?: { root?: IStyle };
  children?: JSX.Element;
  spanOverrideStyles?: IStyle;
  useDefaultLabelStyling?: boolean;
}

const SpanWithLabel = ({
  labelText,
  value,
  stackStyles,
  subLabelText,
  children,
  spanOverrideStyles,
  useDefaultLabelStyling,
}: ISpanWithLabelProps): JSX.Element => {
  const labelClasses = labelStyles();
  let valueString;
  if (typeof value === 'string') {
    value = value.trim();
  }

  if (typeof value === 'boolean') {
    valueString = value ? 'Yes' : 'No';
  } else if (typeof value === 'number') {
    valueString = value.toString();
  } else if ((value as Date) && typeof (value as Date).toDateString === 'function') {
    valueString = (value as Date).toDateString();
  } else if (undefined === value || value === null || value === '') {
    valueString = '--';
  } else {
    valueString = value;
  }

  const spanStyles = mergeStyles(
    {
      wordBreak: 'break-word',
      wordWrap: 'break-word',
      hyphens: 'auto',
    },
    spanOverrideStyles,
  );

  const subSpanStyles = mergeStyles({
    fontSize: '.7rem',
  });

  const stackClassName = stackStyles?.root ? mergeStyles(stackStyles.root) : undefined;
  const labelClassName = useDefaultLabelStyling ? undefined : labelClasses.root;

  return (
    <Stack className={stackClassName}>
      <Label className={labelClassName}>{labelText}</Label>
      {valueString && !children && <span className={spanStyles}>{valueString}</span>}
      {children && !value && <span className={spanStyles}>{children}</span>}
      {subLabelText && <span className={subSpanStyles}>{subLabelText}</span>}
    </Stack>
  );
};

export default SpanWithLabel;
